<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <router-link
              v-if="$route.meta.rtlActive"
              :to="{ path: 'https://www.creative-tim.com' }"
              >منزل</router-link
            >
            <router-link v-else :to="{ path: '/dashboard' }"
              >Dashboard</router-link
            >
          </li>
          <li>
            <a v-if="$route.meta.rtlActive" href="http://blog.creative-tim.com">
              شركة
            </a>
            <router-link v-else :to="{ path: '/Players' }">Players</router-link>
          </li>
          <li>
            <a v-if="$route.meta.rtlActive" href="http://blog.creative-tim.com">
              محفظة
            </a>
            <router-link v-else :to="{ path: '/sponsors' }"
              >Sponsors</router-link
            >
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://www.vinozito.mk" target="_blank">vinozito.mk</a>, made
        with <i class="fa fa-heart heart"></i> for a better life
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
